module.exports = Backbone.Model.extend({
  url: function () {
    return this.baseUrl + (this.id ? 'fonts/' + this.id : 'fonts');
  }
});
